/**
 * Where a floating right unit (components/placements/FloatingPlacement.tsx)
 * may show, as minimum viewport widths. The module details do not float theirs:
 * their right edge is the purchase card, so `content_right` sits IN that column
 * (components/placements/ColumnPlacement.tsx) — and neither does an article: the
 * news and post pages carry a reading sidebar from laptops up, and the unit
 * rides it (D35). A plain module on purpose: the render
 * sites are server components, and a value imported from a "use client" file
 * arrives there as a client REFERENCE, not the number (that bug shipped once —
 * the unit never mounted on the home page).
 *
 * The unit is `UNIT_WIDTH` wide with `UNIT_MARGIN` to the viewport edge, so it
 * fits beside a centred container when the whitespace right of the content —
 * half the viewport surplus plus the container's own inner padding — holds
 * both. `minViewportBeside` is that arithmetic; the container numbers mirror
 * components/ui/Container.tsx (`default` 1440 / `lg:px-10`).
 */
export const UNIT_WIDTH = 260;
export const UNIT_MARGIN = 8;

export function minViewportBeside(containerWidth: number, innerPadding: number): number {
  return containerWidth + 2 * (UNIT_WIDTH + UNIT_MARGIN - innerPadding);
}

/** Laptops and up, overlapping the rightmost ~190–230 px of the default
 *  container. A product decision (2026-09-04): sponsors expect the unit on
 *  laptops, as on their own media site, on the pages whose right edge is a card
 *  grid or a teaser column — home, the listings, the editorial indexes. The
 *  visitor can dismiss it. */
export const FLOATING_MIN_LAPTOP = 1440;
